import React from 'react';

const YellowDangerIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-danger-yellow" />
    </div>
  );
};

export default YellowDangerIcon;
